module.exports = __webpack_public_path__ + "img/bed-front.6dd11002.svg";